import React from 'react'
import Link from 'gatsby-link'

import PageHeader from '../__components/PageHeader'
import PAGE_HEADER from '../img/pageheaders/services_ma.jpg'

import ShareButtons from '../__components/ShareButtons'

const pageMeta = {
  title: "Medical Assessments",
  desc: ''
};
const AboutPage = ({ transition }) => (
  <div style={transition && transition.style} className="page">
    <PageHeader bgPhoto={PAGE_HEADER} cover={true} styles={{ backgroundColor: "#747173" }} />

    {typeof window !== 'undefined' &&
      <ShareButtons location={location.href} desc={pageMeta.desc} />
    }

    <div className="container">
      <div className="title-bar">
        <h1>{pageMeta.title}</h1>
        <p>{pageMeta.desc}</p>
      </div>

      <p>
      Assessments will be performed by Drs Galloway & Olsen on the day of your initial consultation. Your complete medical history will be taken and discussed in detail. This is important to ensure safety and effectiveness of the treatments. Note that certain injections may not be performed at your consultation, depending on your medical history and circumstances on that day. Neuromodulators, including Botox, cannot be administered to any patient who is pregnant, breastfeeding, who has a neuromuscular disorder, or is taking Tetracycline or any aminoglycoside antibiotic. If you hope to have injections performed on the day of your consultation, please refrain from using alcohol, ASA, vitamin E, St. John’s Wort, omega 3, Ginseng, garlic pills, Gingko or any anti-inflammatory medication (Ibuprofen, naproxen) for at least 2 days prior to your treatment, unless they have been prescribed by your physician.  
      </p>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/services-medical-assessment.js